import clsx from 'clsx';
import { useState } from 'react';

type AvatarSize = 'sm' | 'md' | 'lg' | 'xl';

interface AvatarProps {
  initials: string;
  size?: AvatarSize;
  className?: string;
  src?: string;
  alt?: string;
}

const sizeClassNames: Record<AvatarSize, string> = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-12 w-12 text-base',
  xl: 'h-24 w-24 text-2xl sm:h-28 sm:w-28',
};

export default function Avatar({ initials, size = 'md', className, src, alt }: AvatarProps) {
  const [errored, setErrored] = useState(false);
  const showImage = Boolean(src) && !errored;

  return (
    <span
      className={clsx(
        'flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-gray-100 font-semibold text-gray-600',
        sizeClassNames[size],
        className,
      )}
      aria-hidden={!alt}
    >
      {showImage ? (
        <img
          src={src}
          alt={alt ?? ''}
          className="h-full w-full object-cover"
          onError={() => setErrored(true)}
          loading="lazy"
        />
      ) : (
        initials
      )}
    </span>
  );
}
